/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NotificationDetailResponse } from '../models/NotificationDetailResponse';
import type { NotificationListRequest } from '../models/NotificationListRequest';
import type { NotificationListResponse } from '../models/NotificationListResponse';
import type { SubscriptionRequest } from '../models/SubscriptionRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class DefaultService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param uuid
     * @returns NotificationDetailResponse getOneNotification 200 response
     * @throws ApiError
     */
    public getOneNotification(
        uuid: string,
    ): CancelablePromise<NotificationDetailResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/internal/backoffice/notification/{uuid}',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @param requestBody
     * @returns NotificationListResponse getAllNotifications 200 response
     * @throws ApiError
     */
    public getAllNotifications(
        requestBody: NotificationListRequest,
    ): CancelablePromise<NotificationListResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/internal/backoffice/notifications/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param uuid
     * @returns any unsubscribe 200 response
     * @throws ApiError
     */
    public unsubscribe(
        uuid: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/internal/backoffice/unsubscribe/{uuid}',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @param uuid
     * @returns any confirm 200 response
     * @throws ApiError
     */
    public confirm(
        uuid: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/subscription/confirm/{uuid}',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any subscribe 200 response
     * @throws ApiError
     */
    public subscribe(
        requestBody: SubscriptionRequest,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/subscription/subscribe',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param uuid
     * @returns any unsubscribe_1 200 response
     * @throws ApiError
     */
    public unsubscribe1(
        uuid: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/subscription/unsubscribe/{uuid}',
            path: {
                'uuid': uuid,
            },
        });
    }
}
